import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { RestApiService } from '@/services'

import { ApplicationState } from '@/state/root.models'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import ActionTypes from '../constants'

import {
  TwoFactorUserPayload,
  GetBackupCodesResponse,
  UserState,
} from '../models'

const apiService: RestApiService = Container.get(RestApiService)

export const createBackupCodesThunk = createAsyncThunk(
  ActionTypes.CREATE_BACKUP_CODES,
  async (payload: TwoFactorUserPayload, thunkAPI) => {
    try {
      apiService.requestParams = {
        method: 'POST',
        endpoint: 'twoFactorAuthentication/createBackupCodes',
        body: payload,
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: GetBackupCodesResponse = await apiService.sendAuthData(
        auth.token || '',
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      return response
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const createBackupCodesExtraReducer = (
  builder: ActionReducerMapBuilder<UserState>,
) => {
  builder.addCase(createBackupCodesThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(createBackupCodesThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.backupCodes = payload.codes
  })
}

export default createBackupCodesExtraReducer
